/*!
 * Copyright (c) Microsoft Corporation and contributors. All rights reserved.
 * Licensed under the MIT License.
 */
import { NodeKind } from "./core/index.js";
export const ObjectNodeSchema = {
    // instanceof-based narrowing support for Javascript and TypeScript 5.3 or newer.
    [Symbol.hasInstance](value) {
        return isObjectNodeSchema(value);
    },
};
export function isObjectNodeSchema(schema) {
    return schema.kind === NodeKind.Object;
}
//# sourceMappingURL=objectNodeTypes.js.map